(function () {
  var ITEM = '.moonbundle-cart-item';
  var SECTION = '.moonbundle-subscribe-save-section';
  var MUTATION = /\/cart\/(change|update)(\.js)?/;
  var ADD = /\/cart\/add(\.js)?/;
  var CART = /\/cart\/(change|update|add)(\.js)?/;
  var nativeFetch = window.fetch;
  var bundleKeys = null;
  var lastKeys = [];
  var lastItems = [];
  var busy = false;
  var again = false;
  var seq = 0;
  var cartCurrency = 'EUR';
  var chain = Promise.resolve();
  var timer = 0;
  var repairing = {};
  var attempts = {};

  function sameKey(a, b) {
    if (!a || !b) return false;
    a = String(a); b = String(b);
    if (a === b) return true;
    var fa = a.indexOf(':') !== -1, fb = b.indexOf(':') !== -1;
    if (fa && fb) return false;
    return a.split(':')[0] === b.split(':')[0];
  }

  function isBundleKey(key) {
    if (!bundleKeys) return true;
    for (var i = 0; i < bundleKeys.length; i++) if (sameKey(key, bundleKeys[i])) return true;
    return false;
  }

  var MONEY = /€\s?(\d{4,}(?:,\d{1,2})?|\d+\.\d{1,2}(?!\d)|\d{1,3}(?:[.   ]\d{3})*(?:,\d{1,2})?)/g;

  function frenchMoney(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) if (n.nodeValue && n.nodeValue.indexOf('€') !== -1) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) {
      var v = nodes[i].nodeValue;
      var next = v.replace(MONEY, '$1 €');
      if (next !== v) nodes[i].nodeValue = next;
    }
  }

  function isPackLine(it) {
    return !!(it && it.properties && it.properties.__moonbundle !== undefined);
  }

  function euros(cents) {
    var v = Math.round(cents) / 100;
    return (v % 1 ? v.toFixed(2) : String(v)).replace('.', ',') + ' €';
  }

  function packHeadline() {
    if (cartCurrency !== 'EUR') return '';
    var count = 0, paid = 0, full = 0;
    for (var i = 0; i < lastItems.length; i++) {
      var it = lastItems[i];
      if (!isPackLine(it)) continue;
      count += it.quantity || 0;
      paid += it.final_line_price || 0;
      full += it.original_line_price || 0;
    }
    if (!count) return '';
    var txt = 'Compose ton pack · ' + count + ' numéro' + (count > 1 ? 's' : '') + ' · ' + euros(paid);
    if (full > paid) txt += ' au lieu de ' + euros(full);
    return txt;
  }

  function setAttr(el, name, value) {
    if (value === null) { if (el.hasAttribute(name)) el.removeAttribute(name); }
    else if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function mark() {
    frenchMoney(document.querySelector('.moonbundle-cart-drawer'));
    var items = document.querySelectorAll(ITEM + '[data-item-key]');
    var headline = packHeadline();
    var headDone = false;
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var locked = isBundleKey(el.getAttribute('data-item-key'));
      var want = locked ? 'no' : 'ok';
      if (el.getAttribute('data-vw-sub') !== want) el.setAttribute('data-vw-sub', want);
      var fields = el.querySelectorAll(SECTION + ' input,' + SECTION + ' select,' + SECTION + ' button');
      for (var j = 0; j < fields.length; j++) {
        if (locked && !fields[j].disabled) fields[j].disabled = true;
        else if (!locked && fields[j].disabled && fields[j].getAttribute('data-vw-locked') === '1') fields[j].disabled = false;
        if (locked) fields[j].setAttribute('data-vw-locked', '1');
      }
      var pack = locked && bundleKeys !== null;
      setAttr(el, 'data-vw-pack-head', pack && headline && !headDone ? headline : null);
      if (pack && headline && !headDone) headDone = true;
      var title = el.querySelector('.moonbundle-cart-item-title');
      if (title) setAttr(title, 'data-vw-pack-tag', pack ? 'Compose ton pack' : null);
    }
  }

  function cartJson() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } });
  }

  function readCart() {
    var n = ++seq;
    return cartJson()
      .then(function (r) { if (!r || !r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        var items = cart && cart.items;
        if (!Array.isArray(items)) throw new Error('cart');
        if (n !== seq) return items;
        cartCurrency = cart.currency || 'EUR';
        var keys = [];
        var order = [];
        for (var i = 0; i < items.length; i++) {
          order.push(items[i].key);
          if (items[i].properties && items[i].properties.__moonbundle) keys.push(items[i].key);
        }
        bundleKeys = keys;
        lastKeys = order;
        lastItems = items;
        mark();
        return items;
      });
  }

  function packAdd(texte) {
    var payload = readBody(texte);
    if (!payload) return false;
    var items = Array.isArray(payload.items) ? payload.items : [payload];
    for (var i = 0; i < items.length; i++) if (isPackLine(items[i])) return true;
    var keys = Object.keys(payload);
    for (var k = 0; k < keys.length; k++) if (keys[k].indexOf('__moonbundle') !== -1) return true;
    return false;
  }

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function clearPack() {
    return readCart().then(function (items) {
      var updates = {};
      var old = [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!isPackLine(it)) continue;
        updates[it.key] = 0;
        old.push({ id: it.variant_id, quantity: it.quantity, properties: it.properties });
      }
      if (!old.length) return { ok: true, old: old };
      return nativeFetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { if (!r || !r.ok) throw new Error('update'); return r.json(); })
        .then(function () { return readCart(); })
        .then(function (after) {
          for (var j = 0; j < after.length; j++) {
            if (isPackLine(after[j]) && updates.hasOwnProperty(after[j].key)) return { ok: false, old: old };
          }
          return { ok: true, old: old };
        })
        .catch(function () { return { ok: false, old: old }; });
    }).catch(function () { return { ok: false, old: [] }; });
  }

  function restorePack(old) {
    if (!old || !old.length) return Promise.resolve();
    return nativeFetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: old }) })
      .catch(function () {})
      .then(function () { schedule(); });
  }

  function errorJson(status, message) {
    var body = JSON.stringify({ status: status, message: message, description: message });
    try {
      return Promise.resolve(new Response(body, { status: status, headers: { 'Content-Type': 'application/json' } }));
    } catch (e) { return denied(); }
  }

  function serial(fn) {
    var p = chain.then(fn, fn);
    chain = p.then(function () {}, function () {});
    return p;
  }

  var LOCK = 'vw-pack-lock';
  function lock() {
    var start = Date.now();
    return new Promise(function (resolve) {
      (function attempt() {
        var held = 0;
        try { held = parseInt(localStorage.getItem(LOCK), 10) || 0; } catch (e) {}
        if (held && Date.now() - held < 15000 && Date.now() - start < 5000) return setTimeout(attempt, 100);
        try { localStorage.setItem(LOCK, String(Date.now())); } catch (e) {}
        resolve(function () { try { localStorage.removeItem(LOCK); } catch (e) {} });
      })();
    });
  }

  function replacePack(pass) {
    return lock().then(function (release) {
      return clearPack().then(function (res) {
        if (!res.ok) return errorJson(422, 'Le panier n’a pas pu être mis à jour, réessaie dans un instant.');
        return pass().then(function (r) {
          if (r && r.status >= 400 && r.status < 500) return restorePack(res.old).then(function () { return r; });
          return r;
        }, function (e) {
          return readCart().then(function (items) {
            for (var i = 0; i < items.length; i++) if (isPackLine(items[i])) return null;
            return restorePack(res.old);
          }, function () {}).then(function () { throw e; });
        });
      }).then(function (r) { release(); return r; }, function (e) { release(); throw e; });
    });
  }

  function repair(items) {
    var bad = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.properties && it.properties.__moonbundle && it.selling_plan_allocation && !repairing[it.key] && (attempts[it.key] || 0) < 3) bad.push(it);
    }
    if (!bad.length) return Promise.resolve(false);
    var fixed = false;
    var seq = Promise.resolve();
    bad.forEach(function (it) {
      repairing[it.key] = 1;
      attempts[it.key] = (attempts[it.key] || 0) + 1;
      seq = seq.then(function () {
        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity, selling_plan: null })
        }).then(function (r) { if (r && r.ok) fixed = true; }).catch(function () {}).then(function () { delete repairing[it.key]; });
      });
    });
    return seq.then(function () { return fixed; });
  }

  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    readCart()
      .then(function (items) {
        if (items === lastItems) {
          try { document.dispatchEvent(new CustomEvent('vw:cart', { detail: { items: items } })); } catch (e) {}
        }
        return repair(items);
      })
      .catch(function () { return false; })
      .then(function (did) {
        busy = false;
        if (did) window.setTimeout(refresh, 1000);
        else if (again) refresh();
      });
  }

  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () { timer = 0; refresh(); }, 150);
  }

  function touches(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches(ITEM)) return true;
    return !!(node.querySelector && node.querySelector(ITEM));
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (touches(added[j])) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.moonbundle-cart-drawer, ' + ITEM)) schedule();
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.moonbundle-cart-drawer, ' + ITEM)) schedule();
  }, true);

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    try { return String(input); } catch (e) { return ''; }
  }

  function decode(buf) {
    try { if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(buf); } catch (e) {}
    return null;
  }

  function bodyText(body) {
    if (body === undefined || body === null) return '';
    if (typeof body === 'string') return body;
    try {
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.toString();
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var pairs = [];
        body.forEach(function (v, k) { pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v))); });
        return pairs.join('&');
      }
      if (typeof ArrayBuffer !== 'undefined' && (body instanceof ArrayBuffer || ArrayBuffer.isView(body))) return decode(body);
    } catch (e) {}
    return null;
  }

  function bodyTextAsync(body) {
    try {
      if (typeof Blob !== 'undefined' && body instanceof Blob && typeof body.text === 'function') {
        return body.text().then(function (t) { return typeof t === 'string' ? t : null; }, function () { return null; });
      }
    } catch (e) {}
    return Promise.resolve(bodyText(body));
  }

  function requestText(input, init) {
    if (init && init.body !== undefined && init.body !== null) return bodyTextAsync(init.body);
    if (input && typeof input === 'object' && typeof input.clone === 'function') {
      try {
        var ct = '';
        try { ct = String((input.headers && input.headers.get('content-type')) || ''); } catch (e) {}
        if (/multipart\/form-data/i.test(ct) && typeof input.formData === 'function') {
          return input.clone().formData().then(function (fd) { return bodyText(fd); }, function () { return null; });
        }
        return input.clone().text().then(function (t) { return typeof t === 'string' ? t : null; }, function () { return null; });
      } catch (e) { return Promise.resolve(null); }
    }
    return Promise.resolve('');
  }

  function readBody(texte) {
    var t = String(texte || '').trim();
    if (!t) return null;
    if (t.charAt(0) === '{' || t.charAt(0) === '[') {
      try { return JSON.parse(t); } catch (e) { return null; }
    }
    try {
      var p = new URLSearchParams(t);
      var o = {};
      var vide = true;
      p.forEach(function (v, k) { o[k] = v; vide = false; });
      return vide ? null : o;
    } catch (e) { return null; }
  }

  function verdict(payload, keys, order) {
    var plan = payload && payload.selling_plan;
    if (plan === undefined || plan === null || plan === '' || plan === 'null') return false;
    if (keys === null) return null;
    var key = null;
    if (payload.id !== undefined && payload.id !== null) key = String(payload.id);
    else if (payload.line !== undefined) key = order[parseInt(payload.line, 10) - 1] || null;
    if (!key) return true;
    var i;
    for (i = 0; i < keys.length; i++) if (sameKey(key, keys[i])) return true;
    for (i = 0; i < order.length; i++) if (sameKey(key, order[i])) return false;
    return null;
  }

  function judge(texte) {
    if (texte === null) return true;
    var payload = readBody(texte);
    if (!payload) return texte.indexOf('selling_plan') !== -1;
    return verdict(payload, bundleKeys, lastKeys);
  }

  function hasPlan(v) {
    return v !== undefined && v !== null && v !== '' && v !== 'null';
  }

  function forgedAdd(texte) {
    if (texte === null || texte === '') return false;
    var payload = readBody(texte);
    if (!payload) return texte.indexOf('__moonbundle') !== -1 && texte.indexOf('selling_plan') !== -1;
    var items = Array.isArray(payload.items) ? payload.items : [payload];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it && hasPlan(it.selling_plan) && it.properties && typeof it.properties === 'object' && it.properties.__moonbundle !== undefined) return true;
    }
    var keys = Object.keys(payload);
    var bundle = false, plan = false;
    for (var k = 0; k < keys.length; k++) {
      if (keys[k].indexOf('__moonbundle') !== -1) bundle = true;
      if (/selling_plan/.test(keys[k]) && hasPlan(payload[keys[k]])) plan = true;
    }
    return bundle && plan;
  }

  function denied() {
    schedule();
    return cartJson();
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      var method = 'GET';
      try {
        url = urlOf(input);
        method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      } catch (e) {}
      if (method !== 'POST' || !CART.test(url)) return nativeFetch.apply(this, arguments);
      var self = this;
      var args = arguments;
      function pass() {
        var out = nativeFetch.apply(self, args);
        try { out.then(function () { schedule(); }, function () {}); } catch (e) {}
        return out;
      }
      if (ADD.test(url)) {
        return requestText(input, init).then(function (texte) {
          if (forgedAdd(texte)) return denied();
          if (packAdd(texte)) return serial(function () { return replacePack(pass); });
          return pass();
        }, function () { return pass(); });
      }
      return requestText(input, init).then(function (texte) {
        if (texte === '') return nativeFetch.apply(self, args);
        if (texte === null) return denied();
        if (judge(texte) === false) return pass();
        return readCart().then(function () {
          return judge(texte) === false ? pass() : denied();
        }, function () { return denied(); });
      }, function () { return denied(); });
    };
  }

  var xhrProto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (xhrProto && typeof xhrProto.open === 'function' && typeof xhrProto.send === 'function') {
    var nativeOpen = xhrProto.open;
    var nativeSend = xhrProto.send;
    xhrProto.open = function (method, url) {
      try {
        var u = String(url);
        this.__vwCart = CART.test(u);
        this.__vwMutation = String(method).toUpperCase() === 'POST' && MUTATION.test(u);
        this.__vwAdd = String(method).toUpperCase() === 'POST' && ADD.test(u);
      } catch (e) {}
      return nativeOpen.apply(this, arguments);
    };
    xhrProto.send = function (body) {
      var stop = false;
      try {
        if (this.__vwMutation) {
          var texte = bodyText(body);
          stop = texte !== '' && judge(texte) !== false;
        } else if (this.__vwAdd) {
          var t = bodyText(body);
          stop = forgedAdd(t);
          if (!stop && packAdd(t)) {
            var xhr = this;
            var args = arguments;
            serial(function () { return clearPack(); }).then(function () { nativeSend.apply(xhr, args); }, function () { nativeSend.apply(xhr, args); });
            return;
          }
        }
      } catch (e) { stop = true; }
      if (stop) {
        schedule();
        try {
          nativeOpen.call(this, 'GET', '/cart.js', true);
          return nativeSend.call(this);
        } catch (e) {}
        return;
      }
      try { if (this.__vwCart) this.addEventListener('load', function () { schedule(); }); } catch (e) {}
      return nativeSend.apply(this, arguments);
    };
  }

  window.addEventListener('focus', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
